import React from "react";

interface IArrowRightIconProps {
    color?: string;
}

const ArrowRightIcon = ({ color = "#009062" }: IArrowRightIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
            d="M11.4501 8L9.51673 6.06666C9.38340 5.93333 9.31951 5.77778 9.32506 5.6C9.33062 5.42222 9.40006 5.26666 9.5334 5.13333C9.66673 5.01111 9.82229 4.94722 10.0001 4.94166C10.1778 4.93611 10.3334 5 10.4667 5.13333L13.5334 8.2C13.6667 8.33333 13.7334 8.48889 13.7334 8.66666C13.7334 8.84444 13.6667 9 13.5334 9.13333L10.4667 12.2C10.3445 12.3222 10.1917 12.3833 10.0084 12.3833C9.82506 12.3833 9.66673 12.3222 9.5334 12.2C9.40006 12.0667 9.3334 11.9083 9.3334 11.725C9.3334 11.5417 9.40006 11.3833 9.5334 11.25L11.4501 9.33333H5.3334C4.41118 9.33333 3.62506 9.00833 2.97506 8.35833C2.32506 7.70833 2.00006 6.92222 2.00006 6V4C2.00006 3.81111 2.06395 3.65277 2.19173 3.525C2.31951 3.39722 2.47784 3.33333 2.66673 3.33333C2.85562 3.33333 3.01395 3.39722 3.14173 3.525C3.26951 3.65277 3.3334 3.81111 3.3334 4V6C3.3334 6.55555 3.52784 7.02778 3.91673 7.41666C4.30562 7.80555 4.77784 8 5.3334 8H11.4501Z"
            fill={color}
        />
    </svg>
);
export default ArrowRightIcon;
